<template>
    <v-container class="fill-height wrap d-flex align-center">
        <ts-nft-example v-if="tokenId === 'example'" ref="example" :eager="true" class="my-6"></ts-nft-example>
        <ts-nft v-else :screenshot="$route.query && $route.query.screenshot !== undefined" :premint_id="tokenId && tokenId.match(/Bra-(.*)/)[1]"></ts-nft>
    </v-container>
</template>
<script>
import {} from "@mdi/js";
import TsNft from "../components/TsNft.vue";
import TsNftExample from "../components/TsNftExample.vue";

export default {
    name: "BraNFT",
    components: {
        TsNft,
        TsNftExample,
    },
    methods: {},
    computed: {
        tokenId() {
            return this.$route.params ? this.$route.params.token_id : undefined;
        },
    },
    mounted() {
        this.$on("load", function () {
            setTimeout(() => {}, 1000);
        });
    },
    watch: {
        isLoading() {
            const self = this;
            if (!self.isLoading)
                self.$nextTick(() => {
                    setTimeout(function () {}, 1000);
                });
        },
    },
};
</script>
